export const benefits = [
  "Access to paywall stories",
  "Access to NL Chatbox",
  "Access to our subscriber-only Discord server",
  "Access to subscriber-only events, including The Media Rumble and NL Recess",
  "Access to podcast RSS links to listen to our paywall podcasts in apps like Apple and Google Podcasts",
  "Access to NL Baithak"
];

export const hindiBenefits = [
  "पे-वॉल के पीछे मौजूद कहानियों तक पहुंच",
  "एनएल चैटबॉक्स",
  "केवल सब्सक्राइबर्स के लिए उपलब्ध हमारे डिस्कॉर्ड सर्वर की सदस्यता",
  "मीडिया रंबल और एनएल रीसेस सहित केवल सब्सक्राइबर्स के लिए आयोजित कार्यक्रमों में भागीदारी",
  "पे-वॉल के पीछे मौजूद हमारे पॉडकास्ट्स को सुनने के लिए आरएसएस लिंक की उपलब्धता",
  "एनएल बैठक में भाग लेने की सुविधा"
];

export const GROUPS = [
  {
    id: 114,
    name: "Disruptor",
    plans: [
      {
        id: 338,
        name: "Monthly",
        price: 300
      },
      {
        id: 340,
        name: "Annual",
        price: 3000,
        discounts: 600
      }
    ],
    trialPlans: [
      {
        id: 1149,
        name: "Monthly",
        price: 300
      }
    ]
  },
  {
    id: 113,
    name: "Game Changer",
    plans: [
      {
        id: 341,
        name: "Monthly",
        price: 1000
      },
      {
        id: 343,
        name: "Annual",
        price: 10000,
        discounts: 2000
      }
    ]
  }
];
